export default "__VITE_ASSET__31ff7a46__"